import React, { Component } from 'react';
import axios from "axios"
import { Button, Form, Row, Col, Card, Table } from 'react-bootstrap'
import Modal from "../components/modal"
import { connect } from 'react-redux';
import moment from 'moment'

class AdminDiskSpace extends Component {
    state = {
        backupsBySubscriptions: [],
        showInspectBackup: false,
        inspectBackup: null,
        mongoBackups: null,
        backupStatus: []
    }
    interval1 = null
    interval2 = null
    interval3 = null
    componentDidMount() {
        this.interval1 = setInterval(() => {
            this.getBackupCountBySubscription()
        }, 1000)
        this.interval2 = setInterval(() => {
            this.getMongoBackup()
        }, 1000)
        this.interval2 = setInterval(() => {
            this.getStatusCount()
        }, 1000)
    }
    getBackupCountBySubscription = () => {
        axios.get("/api/backup/get/backup/count/by/subscription").then(res => {
            let data = res.data.data
            this.setState({ backupsBySubscriptions: data })
        })
    }
    getMongoBackup = () => {
        axios.get("/api/backup/get/mongo/count").then(res => {
            let data = res.data.data
            this.setState({ mongoBackups: data })
        })
    }
    getStatusCount = () => {
        axios.get("/api/backup/get/status/count").then(res => {
            let data = res.data.data
            this.setState({ backupStatus: data })
        })
    }
    componentWillUnmount() {
        if (this.interval1) {
            clearInterval(this.interval1)
        }
        if (this.interval2) {
            clearInterval(this.interval2)
        }
        if (this.interval3) {
            clearInterval(this.interval3)
        }
    }
    backupRowClicked = (subscription) => {
        axios.post("/api/backup/get/backup/by/subscription", { id: subscription }).then(res => {
            let data = res.data.data
            this.setState({ inspectBackup: data, showInspectBackup: true })
        })
    }
    closeInspect = () => {
        this.setState({ showInspectBackup: false })
    }

    render() {
        let darkmode = this.props.user.darkmode

        let backups = []
        this.state.backupsBySubscriptions.forEach(backup => {
            backups.push(
                <tr onClick={() => this.backupRowClicked(backup.subscriptionItem)}>
                    <td>
                        {backup.subscriptionItem}
                    </td>
                    <td>
                    </td>
                    <td>
                        {backup.backupCount}
                    </td>
                </tr>
            )
        })
        let backupsInspect = []
        backupsInspect.push(
            <thead className={darkmode ? "darkmode-card-content" : "lightmode-card-content"}>
                <tr>
                    <th>id</th>
                    <th>backup type</th>
                    <th>date</th>
                    <th>status</th>
                    <th>sub item</th>
                    <th>Expiry</th>
                    <th>Type</th>
                </tr>
            </thead>

        )
        let backupinstpectdat = []
        if (this.state.inspectBackup) {
            this.state.inspectBackup.backups.forEach(backup => {
                backupinstpectdat.push(
                    <tr>
                        <td>
                            {backup._id}
                        </td>
                        <td>
                            {backup.backuptype}
                        </td>
                        <td>
                            {moment.unix(backup.date).format('DD-MM-YYYY@HH:mm')}
                        </td>
                        <td>
                            {backup.status}
                        </td>
                        <td>
                            {backup.subscriptionItem}
                        </td>
                        <td>
                            {moment.unix(backup.expiryDate).format('DD-MM-YYYY@HH:mm')}
                        </td>
                          <td>
                            {backup.type ? backup.type : ".zip"}
                        </td>
                    </tr>
                )
            })
        }
        backupsInspect.push(
            <tbody className={darkmode ? "darkmode-card-content" : "lightmode-card-content"}>
                {backupinstpectdat}
            </tbody>
        )
        let statuss = []
        statuss = Object.entries(this.state.backupStatus).map(([status, count]) => (
            <Row key={status}>
                <Col>{status}</Col>
                <Col>{count}</Col>
            </Row>
        ));

        return (<div style={{ width: "100%", margin: "auto" }}>
            <Card style={{ margin: '30px' }}>
                <Card.Header className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{ textAlign: 'center' }}>
                    Backup Status's
                </Card.Header>
                <div className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} style={{ maxWidth: '100%' }} >
                    <Row>
                        <Col>
                            Type
                        </Col>
                        <Col>
                            Count
                        </Col>
                    </Row>
                    {statuss}

                </div>
                <Card.Footer className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} >
                </Card.Footer>
            </Card>
            <Card style={{ margin: '30px' }}>
                <Card.Header className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{ textAlign: 'center' }}>
                    Hosting Mongo Backups
                </Card.Header>
                <div className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} style={{ maxWidth: '100%' }} >
                    <Row>
                        <Col>
                            Count
                        </Col>
                    </Row>
                    {this.state.mongoBackups}

                </div>
                <Card.Footer className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} >
                </Card.Footer>
            </Card>
            <Card style={{ margin: '30px' }}>
                <Card.Header className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{ textAlign: 'center' }}>
                    Backups
                </Card.Header>
                <Table className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} style={{ 'margin': '0px' }} bordered>

                    <thead className={darkmode ? "darkmode-card-content" : "lightmode-card-content"}>
                        <tr>
                            <th>
                                Subscription
                            </th>
                            <th>
                                User
                            </th>
                            <th>
                                No.Backups
                            </th>
                        </tr>
                    </thead>
                    <tbody className={darkmode ? "darkmode-card-content" : "lightmode-card-content"}>

                        {backups}
                    </tbody>
                </Table>

                <Card.Footer className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} >
                </Card.Footer>
            </Card>
            <Modal show={this.state.showInspectBackup} title={<h1>Backups</h1>} content={
                <Table className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} style={{ 'margin': '0px' }} bordered>

                    {backupsInspect}
                </Table>
            } close={this.closeInspect} />





        </div>





        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
    }
}
function mapDispatchToProps(dispatch) {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminDiskSpace);






